<template>
    <el-drawer
        title="已选条件模板"
        :size="600"
        :visible.sync="drawer">
        <div class="p20 drawer-page">
            <div class="filter-bar clearfix">
                <el-form :inline="true" class="fl" @submit.native.prevent="submitSearch">
                    <el-form-item label="">
                        <el-input v-model.trim="tempQuery.search" @input="submitSearch" clearable placeholder="请输入模板名称关键字搜索"
                                  style="width: 280px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="fr pt4">
                    <el-badge :value="inboxCount" :hidden="inboxCount<=0" class="mr10">
                        <el-button v-if="!shareMode" size="small" @click="openInbox">模板接收</el-button>
                    </el-badge>
                    <el-button v-if="!shareMode" type="primary" size="small" plain @click="enterShareMode">批量分享</el-button>
                </div>
            </div>
            <div v-if="shareMode" class="share-toolbar clearfix mb10">
                <div class="fl">
                    <el-checkbox :indeterminate="isIndeterminate" :value="isAllChecked" @change="toggleSelectAll">全选本页</el-checkbox>
                    <span class="ml15 text-color-gray">已选 {{selectedIds.length}} 个</span>
                </div>
                <div class="fr">
                    <el-button type="primary" size="mini" :disabled="selectedIds.length<=0" @click="openShareDialog">分享</el-button>
                    <el-button size="mini" @click="exitShareMode">取消</el-button>
                </div>
            </div>
            <div class="data-list" v-loading="dataLoading">
                <p v-if="dataList.length<=0" class="tac m20">暂无数据</p>
                <el-card class="box-card mb6" :class="{'card-checked': shareMode && selectedIds.includes(item.id)}" v-for="item in dataList" :key="item.id">
                    <h4 class="template-name">
                        <el-checkbox v-if="shareMode" class="mr8" :value="selectedIds.includes(item.id)" @change="toggleSelect(item)"></el-checkbox>
                        <template v-if="item.isEdit">
                            <el-input v-model="item.inputVal" :disabled="item.disabled" show-word-limit :maxlength="35" @blur="changeInput(item)" class="inline-block" style="width: 350px;" size="mini" placeholder="请输入模板名称"></el-input>
                        </template>
                        <template v-else>
                            <span class="pr8">{{item.name}}</span>
                            <span v-if="!shareMode" @click="handleEditBtnClick(item)" class="el-icon-edit-outline edit-icon pointer"></span>
                            <el-tag v-if="String(item.creator) !== String(item.uid)" size="mini" type="info" class="ml8">分享自 {{item.creator_name || '他人'}}</el-tag>
                        </template>
                    </h4>
                    <div class="detail mt10 mb10">
                        <p class="ellipsis">
                            <span class="label-text font14px text-color-gray text-bold">筛选条件：</span>
                            <!--<span :title="getConditionText(item)">{{getConditionText(item)}}</span>-->
                            <el-popover
                                placement="top-start"
                                title="筛选条件"
                                width="300"
                                trigger="hover">
                                <span> {{getConditionText(item)}}</span>
                                <span slot="reference"> {{getConditionText(item)}}</span>
                            </el-popover>
                        </p>
                        <p class="ellipsis">
                            <span class="label-text font14px text-color-gray text-bold">维度分组：</span>
                            <!--<span :title="getDimensionText(item)">{{getDimensionText(item)}}</span>-->
                            <el-popover
                                placement="top-start"
                                title="维度分组"
                                width="300"
                                trigger="hover">
                                <span> {{getDimensionText(item)}}</span>
                                <span slot="reference"> {{getDimensionText(item)}}</span>
                            </el-popover>
                        </p>
                        <p class="ellipsis">
                            <span class="label-text font14px text-color-gray text-bold">数据指标：</span>
                            <el-popover
                                placement="top-start"
                                title="数据指标"
                                width="300"
                                trigger="hover">
                                <span> {{getFieldText(item)}}</span>
                                <span slot="reference"> {{getFieldText(item)}}</span>
                            </el-popover>
                        </p>
                    </div>
                    <div class="quick-btn clearfix" v-if="!shareMode">
                        <div class="fl">
                            <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `模版(应用模板)` }" type="primary" size="large" :loading="item.useLoading" @click="useTemplate(item)">应用模板</el-button>
                        </div>
                        <div class="fr pt12">
                            <!--<el-button type="info" size="mini" plain>导出数据</el-button>-->
                            <span class="mr20">
                                <el-checkbox v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `模版(默认展示)` }" true-label="1" false-label="0" :value="item.is_default" @change="setDefault(item)">默认展示</el-checkbox>
                            </span>
                            <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `模版(取消置顶)` }" v-if="item.is_top=='1'" type="primary" size="mini" @click="toggleIsTop(item)" :loading="item.topLoading" plain>取消置顶</el-button>
                            <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `模版(置顶)` }" v-else type="primary" size="mini" @click="toggleIsTop(item)" :loading="item.topLoading">置顶</el-button>

                            <el-popconfirm
                                title="确定要删除该模板吗？"
                                confirm-button-text="删除"
                                confirm-button-type="danger"
                                @confirm="deleteTemplate(item)"
                                placement="top-end"
                            >
                                <el-button slot="reference" type="danger" class="ml10" size="mini" :loading="item.deleteLoading" plain>删除模板</el-button>
                            </el-popconfirm>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="page-bar tac mt20">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="queryData.pn"
                    :page-sizes="[5,10, 20,50]"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="分享模板" :visible.sync="shareDialogVisible" :append-to-body="true" :close-on-click-modal="false" width="520px" @closed="onShareDialogClosed">
            <p class="mb10 text-color-gray">将分享选中的 <b>{{selectedIds.length}}</b> 个模板给以下同事（副本，对方可独立修改）：</p>
            <el-select
                v-model="selectedUsers"
                multiple
                filterable
                remote
                reserve-keyword
                :remote-method="remoteSearchUser"
                :loading="userLoading"
                :max-collapse-tags="3"
                collapse-tags
                placeholder="输入姓名 / 工号 / 手机搜索同事"
                style="width: 100%;"
                no-data-text="无匹配用户"
                loading-text="搜索中…"
            >
                <el-option
                    v-for="u in mergedUserOptions"
                    :key="u.id"
                    :label="u.name + (u.group_name_with_parent ? ('（' + u.group_name_with_parent + '）') : '')"
                    :value="u.id">
                    <span>{{u.name}}</span>
                    <span class="user-dept">{{u.group_name_with_parent}}</span>
                </el-option>
            </el-select>
            <span slot="footer">
                <el-button size="small" @click="shareDialogVisible=false">取消</el-button>
                <el-button size="small" type="primary" :loading="submitLoading" :disabled="selectedUsers.length<=0" @click="doShare">确定分享</el-button>
            </span>
        </el-dialog>

        <el-dialog title="模板接收" :visible.sync="inboxVisible" :append-to-body="true" :close-on-click-modal="false" width="560px">
            <div v-loading="inboxLoading" class="inbox-wrap">
                <p v-if="inboxGroups.length<=0" class="tac text-color-gray m20">暂无待接收的模板</p>
                <div v-for="g in inboxGroups" :key="g.from_uid" class="inbox-group mb15">
                    <div class="inbox-group-head clearfix">
                        <span class="fl">
                            <b>{{g.from_name}}</b>
                            <span class="text-color-gray ml8" v-if="g.from_dept">{{g.from_dept}}</span>
                            <span class="ml8">分享了 {{g.count}} 个</span>
                        </span>
                        <span class="fr">
                            <el-button type="text" :disabled="inboxSubmitting" @click="acceptIds(groupIds(g))">全部接收</el-button>
                            <el-button type="text" class="text-color-gray" :disabled="inboxSubmitting" @click="rejectIds(groupIds(g))">全部拒绝</el-button>
                        </span>
                    </div>
                    <div v-for="it in g.items" :key="it.id" class="inbox-item clearfix">
                        <span class="fl ellipsis inbox-item-name">{{it.name}}</span>
                        <span class="fr">
                            <el-button size="mini" type="primary" plain :disabled="inboxSubmitting" @click="acceptIds([it.id])">接收</el-button>
                            <el-button size="mini" plain :disabled="inboxSubmitting" @click="rejectIds([it.id])">拒绝</el-button>
                        </span>
                    </div>
                </div>
            </div>
        </el-dialog>
    </el-drawer>
</template>

<script>
    import API from '@/api/dataCenter.js';

    export default {
        name: "TemplateListDrawer",
        components: {},
        props: {
            platId:{
                type: [String,Number],
                required: true,
            },
        },
        data() {
            return {
                drawer: false,
                dataLoading: false,
                queryData: {
                    search: '',
                    pn: 1,
                    rn: 10
                },
                tempQuery: {
                    search: '',
                },
                dataList: [],
                totalCnt: 0,
                isEdit:false,
                // 分享相关
                shareMode: false,
                selectedIds: [],
                shareDialogVisible: false,
                userOptions: [],          // 当前搜索结果
                selectedUserObjs: [],     // 已选用户对象缓存（含 name/部门，跨搜索保留 label）
                selectedUsers: [],        // 已选 uid
                userLoading: false,
                submitLoading: false,
                _userSearchTimer: null,
                // 收件箱
                inboxVisible: false,
                inboxLoading: false,
                inboxGroups: [],
                inboxCount: 0,
                inboxSubmitting: false,
            }
        },
        computed: {
            isAllChecked(){
                return this.dataList.length>0 && this.dataList.every(item=>this.selectedIds.includes(item.id));
            },
            isIndeterminate(){
                let checked = this.dataList.filter(item=>this.selectedIds.includes(item.id)).length;
                return checked>0 && checked<this.dataList.length;
            },
            // 选项 = 搜索结果 ∪ 已选（保证已选 tag 始终有 label，不退化成 id）
            mergedUserOptions(){
                let map = {};
                this.selectedUserObjs.concat(this.userOptions).forEach(u=>{ if(!map[u.id]) map[u.id]=u; });
                return Object.values(map);
            },
        },
        watch: {
            selectedUsers(ids){
                let pool = {};
                this.selectedUserObjs.concat(this.userOptions).forEach(u=>{ if(!pool[u.id]) pool[u.id]=u; });
                this.selectedUserObjs = ids.map(id=> pool[id] || {id, name: '用户'+id, group_name_with_parent: ''});
            },
        },
        methods: {
            showDrawer() {
                this.drawer = true;
                this.$nextTick(() => {
                    this.getDataList();
                    this.loadInboxCount();
                })
            },
            hideDrawer(){
                this.drawer = false;
                this.dataList = [];
                this.tempQuery.search = this.queryData.search = '';
                this.exitShareMode();
                this.inboxVisible = false;
            },
            // ===== 收件箱（模板接收）=====
            loadInboxCount(){
                API.getShareInbox({plat_id:this.platId||'0'}).then(res=>{
                    let groups = res.data||[];
                    this.inboxCount = groups.reduce((s,g)=>s+(g.count||0),0);
                }, ()=>{});
            },
            openInbox(){
                this.inboxVisible = true;
                this.loadInbox();
            },
            loadInbox(){
                this.inboxLoading = true;
                API.getShareInbox({plat_id:this.platId||'0'}).then(res=>{
                    this.inboxGroups = res.data||[];
                    this.inboxCount = this.inboxGroups.reduce((s,g)=>s+(g.count||0),0);
                    this.inboxLoading = false;
                },err=>{
                    this.inboxGroups = [];
                    this.inboxLoading = false;
                    this.$message.error((err&&err.info)||'加载收件箱失败');
                });
            },
            groupIds(g){
                return (g.items||[]).map(i=>i.id);
            },
            acceptIds(ids){
                if(this.inboxSubmitting || !ids.length) return;
                this.inboxSubmitting = true;
                API.acceptShare({share_ids:ids}).then(res=>{
                    this.inboxSubmitting = false;
                    let d = res.data||{}, fail = d.fail_list||[];
                    if(fail.length){
                        this.$message.warning(`接收 ${d.success_count||0} 个，${fail.length} 个未成功`);
                    }else{
                        this.$message.success(`已接收 ${d.success_count||0} 个模板`);
                    }
                    this.loadInbox();
                    this.updateList();
                },err=>{
                    this.inboxSubmitting = false;
                    this.$message.error((err&&err.info)||'接收失败');
                });
            },
            rejectIds(ids){
                if(this.inboxSubmitting || !ids.length) return;
                this.inboxSubmitting = true;
                API.rejectShare({share_ids:ids}).then(res=>{
                    this.inboxSubmitting = false;
                    this.$message.success('已拒绝');
                    this.loadInbox();
                },err=>{
                    this.inboxSubmitting = false;
                    this.$message.error((err&&err.info)||'拒绝失败');
                });
            },
            enterShareMode(){
                this.shareMode = true;
                this.selectedIds = [];
            },
            exitShareMode(){
                this.shareMode = false;
                this.selectedIds = [];
                this.shareDialogVisible = false;
            },
            toggleSelect(item){
                let idx = this.selectedIds.indexOf(item.id);
                if(idx>=0){ this.selectedIds.splice(idx,1); }
                else { this.selectedIds.push(item.id); }
            },
            toggleSelectAll(checked){
                if(checked){
                    this.dataList.forEach(item=>{ if(!this.selectedIds.includes(item.id)) this.selectedIds.push(item.id); });
                }else{
                    let pageIds = this.dataList.map(item=>item.id);
                    this.selectedIds = this.selectedIds.filter(id=>!pageIds.includes(id));
                }
            },
            openShareDialog(){
                if(this.selectedIds.length<=0) return this.$message.warning('请先勾选要分享的模板');
                this.selectedUsers = [];
                this.selectedUserObjs = [];
                this.userOptions = [];
                this.shareDialogVisible = true;
            },
            onShareDialogClosed(){
                this.selectedUsers = [];
                this.selectedUserObjs = [];
                this.userOptions = [];
            },
            remoteSearchUser(query){
                clearTimeout(this._userSearchTimer);
                let kw = (query||'').trim();
                if(!kw){ this.userOptions = []; return; }
                this._userSearchTimer = setTimeout(()=>{
                    this.userLoading = true;
                    API.searchShareUser({search:kw}).then(res=>{
                        this.userOptions = res.data||[];
                        this.userLoading = false;
                    },err=>{
                        this.userOptions = [];
                        this.userLoading = false;
                        this.$message.error((err&&err.info)||'搜索用户失败');
                    });
                },300);
            },
            doShare(){
                if(this.selectedUsers.length<=0) return this.$message.warning('请选择分享对象');
                let names = this.selectedUserObjs.filter(u=>this.selectedUsers.includes(u.id)).map(u=>u.name);
                let nameStr = names.slice(0,5).join('、') + (names.length>5?`等 ${names.length} 人`:'');
                this.$confirm(`将把 ${this.selectedIds.length} 个模板分享给：${nameStr}，确认？`, '确认分享', {
                    confirmButtonText: '确认分享',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(()=>{
                    this.submitLoading = true;
                    API.shareTemplate({
                        plat_id: this.platId,
                        template_ids: this.selectedIds,
                        to_uids: this.selectedUsers,
                    }).then(res=>{
                        this.submitLoading = false;
                        let data = res.data||{};
                        let fail = data.fail_list||[];
                        if(fail.length<=0){
                            this.$message.success(`已分享，成功创建 ${data.success_count||0} 个副本`);
                        }else{
                            this.$notify({
                                title: '部分分享未成功',
                                type: 'warning',
                                duration: 0,
                                message: `成功 ${data.success_count||0} 个；失败 ${fail.length} 项（用户不存在/已禁用或写入失败），请核对后重试`,
                            });
                        }
                        this.shareDialogVisible = false;
                        this.exitShareMode();
                    },err=>{
                        this.submitLoading = false;
                        this.$message.error((err&&err.info)||'分享失败');
                    });
                }).catch(()=>{});
            },
            getDataList() {
                this.dataLoading = true;
                API.getTemplateList({
                    search: this.queryData.search,
                    plat_id:this.platId||'0',
                    all:0,
                    pn: this.queryData.pn,
                    rn: this.queryData.rn,
                }).then(res => {
                    let resData = res.data||{};
                    this.dataLoading = false;
                    this.dataList = (resData.list||[]).map(item=>{
                        item.isEdit = false;
                        item.disabled = false;
                        item.inputVal = item.name;
                        item.topLoading = false;
                        item.deleteLoading = false;
                        item.useLoading = false;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                }, (err) => {
                    console.log('getTemplateList error', err);

                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            submitSearch() {
                this.queryData.pn = 1;
                this.queryData.search = this.tempQuery.search;
                this.getDataList();
            },
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn = val;
                this.getDataList();
            },
            updateList() {
                this.getDataList();
                this.$emit('update');
            },
            handleEditBtnClick(item){
                item.isEdit = true;
                item.inputVal = item.name;
            },
            changeInput(item){
                if(item.inputVal == item.name){
                    item.isEdit = false;
                    return false;
                }else if(!item.inputVal){
                    item.inputVal = item.name;
                    return this.$message.error('模板名称不能为空');
                }else{
                    item.disabled = true;
                    API.modifyTemplateName({
                        id:item.id,
                        name:item.inputVal,
                        plat_id:this.platId,
                    }).then(res=>{
                        item.name = item.inputVal;
                        this.$message.success(res.info||'操作成功');
                        item.disabled = false;
                        item.isEdit = false;
                    },err=>{
                        this.$message.error(err.info||'操作失败');
                        item.disabled = false;
                    })
                }

            },
            setDefault(item){
                item.defaultLoading = true;
                API.setDefaultTemplate({
                    plat_id:this.platId,
                    id:item.id,
                    is_default:item.is_default=='1'?'0':'1',
                }).then(res=>{
                    item.defaultLoading = false;
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                },err=>{
                    this.$message.error(err.info||'操作失败');
                    item.defaultLoading = false;
                })
            },
            toggleIsTop(item){
                item.topLoading = true;
                API.topTemplate({
                    plat_id:this.platId,
                    id:item.id,
                    is_top:item.is_top=='1'?'0':'1',
                }).then(res=>{
                    item.topLoading = false;
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                },err=>{
                    this.$message.error(err.info||'操作失败');
                    item.topLoading = false;
                })
            },
            deleteTemplate(item){
                let actionItem = this.dataList.find(inner=>inner.id===item.id);
                actionItem.deleteLoading = true;
                API.deleteTemplate({
                    plat_id:this.platId,
                    id:item.id,
                }).then(res=>{
                    actionItem.deleteLoading = false;
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                },err=>{
                    actionItem.deleteLoading = false;
                    this.$message.error(err.info||'操作失败');
                })
            },
            getFieldText(item){
                return (item.field_config||[]).map(field=>field.display_name).join('、')||'未设置';
            },
            getDimensionText(item){
                return (item.dimension_config||[]).map(field=>field.display_name+(field.sub_text?('('+field.sub_text+')'):'')).join('、')||'未设置';
            },
            getConditionText(item){
                return (item.condition_config||[]).map(field=>field.display_name).join('、')||'未设置';
            },
            useTemplate(item){
                this.$emit('use-template',item);
                item.useLoading = true;
            },
        }
    }
</script>

<style scoped>
    ::v-deep .el-drawer__header {
        padding: 15px 20px;
        margin: 0;
        border-bottom: solid 1px #dcdee2;
        font-weight: bold;
        color: #333;
    }

    ::v-deep.template-name .el-input__suffix{
        right: -40px!important;
    }

    .template-name{
        line-height: 28px;
    }

    .edit-icon{
        color: #66b1ff;
        font-size: 16px;
    }

    .share-toolbar{
        padding: 8px 12px;
        background: #f5f7fa;
        border-radius: 4px;
        line-height: 28px;
    }
    .card-checked{
        border-color: #409eff;
        box-shadow: 0 0 0 1px #409eff inset;
    }
    .user-dept{
        float: right;
        color: #8492a6;
        font-size: 12px;
        margin-left: 12px;
    }
    .pt4{ padding-top: 4px; }
    .ml8{ margin-left: 8px; }
    .mr8{ margin-right: 8px; }
    .mr10{ margin-right: 10px; }
    .ml15{ margin-left: 15px; }

    .inbox-wrap{ max-height: 56vh; overflow-y: auto; }
    .inbox-group-head{
        padding: 6px 10px; background: #f5f7fa; border-radius: 4px; line-height: 28px;
    }
    .inbox-item{
        padding: 6px 10px; border-bottom: 1px solid #ebeef5; line-height: 28px;
    }
    .inbox-item-name{ max-width: 360px; }

</style>
